var exports = {
  "pt": "xdbfd91f1--ade409--top_card",
  "_q": "xdbfd91f1--ade409--sub_card",
  "DD": "xdbfd91f1--ade409--title",
  "U9": "xdbfd91f1--ade409--count",
  "sW": "xdbfd91f1--ade409--object_header",
  "VX": "xdbfd91f1--ade409--object_title",
  "OO": "xdbfd91f1--ade409--object_price",
  "nf": "xdbfd91f1--ade409--link",
};

module.exports = exports;
